export default "__VITE_ASSET__BJmzHzTn__"